import type { AttributeDto, AttributesListDto, ChannelCategoriesDto } from '@repo/api/web/models'
import { defineStore } from 'pinia'

import type { CategoryDto } from '#Products/models/Pim/CategoryDto'

export const usePimStore = defineStore('pim', () => {
  const categories = ref<ChannelCategoriesDto & { allByIds: CategoryDto[] }>()
  const attrs = ref<AttributesListDto & { allByIds: Record<string, AttributeDto> }>()

  return {
    categories,
    attrs,
  }
})
